<template>
  <a-row :gutter="10">
    <a-col :md="4" :sm="24">
      <a-card :bordered="false">
          <span style="user-select: none" v-if="colTreeData">
            <a-tree  :default-expand-all="true" :show-line="true"
                    :tree-data="colTreeData"
                    @select="onSelect"><!--:show-line="true"-->
            </a-tree>
          </span>
      </a-card>
    </a-col>
    <a-col :md="20" :sm="24">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="'欄目'">
                  <a-input  v-model="selectColName" disabled></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="'內容编码'">
                  <a-input  v-model="queryParam.contentCode" allowClear></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="'名称'">
                  <a-input  v-model="queryParam.contentName" allowClear></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="'状态'">
                  <j-dict-select-tag  v-model="queryParam.status" dictCode="empzone_col_status" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchData" icon="search">{{this.language['common.searchButton']}}</a-button>
                <a-button type="primary" @click="searchResetData" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
              </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- 操作按钮区域 -->
        <div class="table-operator" v-if="!!selectColId">
          <a-button @click="add" type="primary" icon="plus">新增</a-button>
        </div>

        <!-- table区域-begin -->
        <div>

          <a-table
            ref="table"
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <!--<a @click="handleEdit(record)">编辑</a>-->
          <a @click="publish(record)" v-if="record.status=='unpublished'">{{language['emp.col.status.publish']}}</a>
          <a @click="unpublish(record)" v-if="record.status=='published'">{{language['emp.col.status.unpublish']}}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="detail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

          </a-table>
        </div>

        <!--<empzone-col-content-modal ref="modalForm" @ok="modalFormOk"></empzone-col-content-modal>-->
        <empzone-content-modal ref="modalForm" @ok="modalFormOk"></empzone-content-modal>
      </a-card>
      <j-modal
        title="新增"
        :width="1000"
        :visible="addVisible"
        switchFullscreen
        :ok-disabled="true"
        :okButtonProps="{ class:{'jee-hidden': false} }"
        @cancel="addCancel"
        cancelText="关闭">

        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="initAddData(1)">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="'內容编码'">
                  <a-input  v-model="addQueryParam.contentCode" allowClear></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="'內容名称'">
                  <a-input  v-model="addQueryParam.contentName" allowClear></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="initAddData(1)" icon="search">{{language['common.searchButton']}}</a-button>
                  <a-button type="primary" @click="addReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
            <a-table
              ref="table"
              size="middle"
              :scroll="{x:true}"
              bordered
              rowKey="id"
              :columns="contentColumns"
              :dataSource="contentDataSource"
              :pagination="contentIpagination"
              @change="addTableChange"
              class="j-table-force-nowrap">

              <span slot="action" slot-scope="text, record">
                <a @click="addContent(record)" :disabled="record.hasCol=='1'">添加</a>
              </span>

            </a-table>


      </j-modal>
    </a-col>
  </a-row>

</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpzoneColContentModal from './modules/EmpzoneColContentModal'
  import EmpzoneContentModal from '../content/modules/EmpzoneContentModal'
  import { httpAction, getAction,postAction } from '@/api/manage'

  export default {
    name: 'EmpzoneColContentList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EmpzoneColContentModal,
      EmpzoneContentModal
    },
    data () {
      return {
        // colTreeExpandedKeys:[],
        colTreeData:[],
        selectColId:'',
        selectCode:'',
        selectColName:'',

        addQueryParam:{},
        addVisible:false,
        contentDataSource:[],
        contentIpagination:{
          current: 1,
          pageSize: 10,
          showQuickJumper: false,
          showSizeChanger: false,
          total: 0
        },
        contentColumns:[
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'内容編碼',
            align:"center",
            dataIndex: 'contentCode'
          },
          {
            title:'内容名称',
            align:"center",
            dataIndex: 'contentName'
          },
          {
            title:'内容类型',
            align:"center",
            dataIndex: 'contentType_dictText'
          },
          {
            title:'发布时间',
            align:"center",
            dataIndex: 'publishedTime',
            customRender:function (text,record) {
              if(record.status == 'published'){
                return !text?"":(text.length>19?text.substr(0,19):text)
              }else{
                return "";
              }
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],

        // disableMixinCreated: true,
        description: '欄目內容管理页面',
        // 表头
        columns: [
          /*{
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },*/
          /*{
            title:'栏目id',
            align:"center",
            dataIndex: 'colId'
          },*/
          /*{
            title:'栏目code',
            align:"center",
            dataIndex: 'colCode'
          },*/
          /*{
            title:'内容id',
            align:"center",
            dataIndex: 'contentId'
          },*/
          {
            title:'内容',
            align:"center",
            dataIndex: 'contentCode'
          },
          {
            title:'内容名称',
            align:"center",
            dataIndex: 'contentName'
          },
          {
            title:'欄目',
            align:"center",
            dataIndex: 'colName'
          },
          {
            title:'排序',
            align:"center",
            dataIndex: 'sortNo'
          },
          {
            title:'状态',
            align:"center",
            dataIndex: 'status_dictText'
          },
          {
            title:'发布时间',
            align:"center",
            dataIndex: 'publishedTime',
            customRender:function (text,record) {
              if(record.status == 'published'){
                return !text?"":(text.length>19?text.substr(0,19):text)
              }else{
                return "";
              }
              // return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          /*{
            title:'发布人id',
            align:"center",
            dataIndex: 'publishedUserId'
          },*/
          {
            title:'創建人',
            align:"center",
            dataIndex: 'createrName'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/empzone/colContent/pagelist",
          delete: "/empzone/colContent/delete",
          publishUrl:"/empzone/colContent/publishstatus",
          deleteBatch: "/colContent/empzonecolcontent/batch",
          exportXlsUrl: "/colContent/export-xls",
          importExcelUrl: "colContent/import-excel",
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
      this.colTreeData = [];
      getAction("/empzone/col/getAlllist",{status:'Y'}).then(res=>{
        if(res.success){
          let list = res.result
          if(list&&list.length>0){
            list.forEach(item=>{
              let map = {};
              map.title = item.colName
              map.key = item.id
              map.colCode = item.colCode
              let children = this.initChildren(item)
              if(children&&children.length>0){
                map.children = children;
              }
              this.colTreeData.push(map);
            })
          }
          /*this.$nextTick(() => {
            this.colExpandedKeys = [...this.expandedKeys]
          })*/
        }
      })
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      addCancel(){
        this.addVisible = false;
        this.searchData();
      },
      addContent(record){
        let map = {
          "colId":this.selectColId,
          "colCode":this.selectColCode,
          "contentId":record.id,
          "contentCode":record.contentCode,
          "contentName":record.contentName,
          "status":"unpublished"
        }
        postAction("/empzone/colContent/add",map).then(res=>{
          if(res.success){
            record.hasCol = '1';
            this.$message.success("操作成功");
          }else{
            this.$message.warning("操作失敗，請聯繫管理員");
          }
        })
      },
      add(){
        this.addVisible = true;
        this.contentDataSource = [],
        this.contentIpagination = {
          current: 1,
          pageSize: 10,
          showQuickJumper: false,
          showSizeChanger: false,
          total: 0
        }
        this.initAddData()
        //初始化contentDataSource數據
        // this.$refs.modalForm.addData(this.selectColId,this.selectColCode,this.selectColName)
      },
      initAddData(pageNo){
        if(pageNo)this.contentIpagination.current = pageNo
        let param = this.addQueryParam;
        param.pageNo = this.contentIpagination.current;
        param.pageSize = this.contentIpagination.pageSize;
        param.withoutColId = this.selectColId;
        param.status = 'published';
        getAction("/empzone/content/pagelist",param).then(res=>{
          if(res.success){
            this.contentDataSource = res.result.records;
            this.contentIpagination.total = res.result.total;
          }
        })
      },
      addReset(){
        this.addQueryParam = {}
        this.initAddData(1);
      },
      addTableChange(ipagination){
        this.contentIpagination = ipagination
        this.initAddData()
      },
      initChildren(data){
        let relist = [];
        if(data.children&&data.children.length>0){
          for(let i=0;i<data.children.length;i++){
            let map = {};
            map.title = data.children[i].colName
            map.key = data.children[i].id
            map.colCode = data.children[i].colCode
            let children = this.initChildren(data.children[i])
            if(children&&children.length>0){
              map.children = children;
            }
            relist.push(map);
          }
        }
        return relist;
      },
      onSelect(selectedKeys, info) {
        // this.colTreeExpandedKeys = selectedKeys
        if(selectedKeys.length>0){
          this.selectColId = selectedKeys[0]
          this.selectColName = info.node.title;
          this.selectColCode = info.selectedNodes[0].data.props.colCode
          this.queryParam = {colId:this.selectColId}
          this.searchQuery();
        }else{
          this.selectColId = ''
          this.selectColName = '';
          this.selectColCode = ''
          this.searchReset()
        }
      },

      /*onCheck(checkedKeys, info) {
        console.log('onCheck', checkedKeys, info);
      },*/

      searchData(){
        if(this.selectColId){
          this.queryParam.colId = this.selectColId
        }
        this.searchQuery()
      },
      searchResetData(){
        if(this.selectColId){
          this.queryParam = {colId:this.selectColId}
        }
        this.searchQuery()
      },
      publish(record){
        var that = this;
        //上架
        this.$confirm({
          title:'發佈',
          content:'是否確認發佈?',
          onOk: function(){
            getAction(that.url.publishUrl,{id:record.id,status:'published'}).then((res)=>{
              if(res.success){
                that.$message.success(that.language["operationSuccess"]);
                record.status = 'published'
                record.status_dictText = '發佈'
                record.publishedTime = res.result.publishedTime
                // that.searchData();
                // that.onClearSelected();
              }else{
                that.$message.warn(that.language['common.errorContext'])
              }
            });
          }
        });
      },
      unpublish(record){
        var that = this;
        //上架
        this.$confirm({
          title:'下架',
          content:'是否確認下架?',
          onOk: function(){
            getAction(that.url.publishUrl,{id:record.id,status:'unpublished'}).then((res)=>{
              if(res.success){
                that.$message.success(that.language["operationSuccess"]);
                record.status = 'unpublished'
                record.status_dictText = '未發佈'
                // that.searchData();
                // that.onClearSelected();
              }else{
                that.$message.warn(that.language['common.errorContext'])
              }
            });
          }
        });
      },
      detail(record){
        getAction("/empzone/content/queryById/"+record.contentId).then(res=>{
          if(res.success){
            let data = res.result
            this.handleDetail(data)
          }
        })

      },
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'colId',text:'栏目id',dictCode:''})
        fieldList.push({type:'string',value:'colCode',text:'栏目code',dictCode:''})
        fieldList.push({type:'string',value:'contentId',text:'内容id',dictCode:''})
        fieldList.push({type:'string',value:'contentCode',text:'内容code',dictCode:''})
        fieldList.push({type:'string',value:'contentName',text:'内容名称',dictCode:''})
        fieldList.push({type:'string',value:'sortNo',text:'排序',dictCode:''})
        fieldList.push({type:'string',value:'status',text:'状态(published:已发布；nupublished:未发布)',dictCode:''})
        fieldList.push({type:'date',value:'publishedTime',text:'发布时间'})
        fieldList.push({type:'string',value:'publishedUserId',text:'发布人id',dictCode:''})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
